import type { IconProps } from './types';

export const User01Icon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M5 21.8734V15.9241C5 15.9241 7.5 13.7812 12.5 13.7812M19.8125 21.9047V15.9553C19.8125 15.9553 17.3125 13.8125 12.3125 13.8125M8.75094 6.74906C8.75094 7.2414 8.84791 7.72891 9.03632 8.18377C9.22473 8.63862 9.50088 9.05192 9.84901 9.40005C10.1971 9.74818 10.6104 10.0243 11.0653 10.2127C11.5202 10.4012 12.0077 10.4981 12.5 10.4981C12.9923 10.4981 13.4798 10.4012 13.9347 10.2127C14.3896 10.0243 14.8029 9.74818 15.151 9.40005C15.4991 9.05192 15.7753 8.63862 15.9637 8.18377C16.1521 7.72891 16.2491 7.2414 16.2491 6.74906C16.2491 5.75475 15.8541 4.80116 15.151 4.09807C14.4479 3.39499 13.4943 3 12.5 3C11.5057 3 10.5521 3.39499 9.84901 4.09807C9.14593 4.80116 8.75094 5.75475 8.75094 6.74906Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
